import { render, staticRenderFns } from "./RefundPage.vue?vue&type=template&id=1b9a1c46&scoped=true"
import script from "./RefundPage.vue?vue&type=script&lang=js"
export * from "./RefundPage.vue?vue&type=script&lang=js"
import style0 from "./RefundPage.vue?vue&type=style&index=0&id=1b9a1c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a1c46",
  null
  
)

export default component.exports